import { Button, Text } from '@ui/themed';
import { t } from 'i18next';
import { useCallback, useState } from 'react';
import { SparkSuspense } from '../../../components/spark-suspense';
import { useGetCustomer } from '../../customers/hooks/use-get-customer';
import type { CustomerMinimal } from '../types/company';
import { CompanyUserCard } from './company-user-card';
import { CustomerSearchSelect } from './customer-search-select';

export function AddCompanyUser({
  disabled,
  onAddCompanyUser,
  onCancel,
}: {
  disabled: boolean;
  onAddCompanyUser: (customer: CustomerMinimal) => void;
  onCancel: () => void;
}) {
  const [selectedCustomer, setSelectedCustomer] = useState('');

  const {
    data: customer,
    isLoading,
    isError,
    refetch,
  } = useGetCustomer({ by: 'sparklayer', identifier: selectedCustomer });

  const handleAddCompanyUser = useCallback(() => {
    if (!disabled && customer) {
      onAddCompanyUser(customer);
    }
  }, [disabled, customer, onAddCompanyUser]);

  return (
    <div className="flex h-full flex-col gap-2">
      <Text>{t('features:sections.components.add_company_user.description')}</Text>
      <CustomerSearchSelect value="" onChange={setSelectedCustomer} />
      <SparkSuspense
        isError={isError}
        isLoading={isLoading}
        onReload={refetch}
        errorMessage={t('features:sections.components.add_company_user.error')}
      >
        {customer && <CompanyUserCard customer={customer} />}
      </SparkSuspense>
      <div className="flex flex-grow items-end justify-end gap-2">
        <Button variant="secondary" onClick={onCancel}>
          {t('buttons:cancel')}
        </Button>
        <Button
          disabled={!customer || disabled}
          loading={isLoading}
          onClick={() => handleAddCompanyUser()}
        >
          {t('buttons:save')}
        </Button>
      </div>
    </div>
  );
}
